var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficientAndHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4994,
    cy: 57.5007,
    r: 52.305,
    fill: "url(#paint0_linear_126_569)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19434 57.5007C5.19434 86.388 28.6121 109.806 57.4994 109.806V45.5472H6.56647C5.66898 49.3863 5.19434 53.3881 5.19434 57.5007Z",
    fill: "url(#paint1_linear_126_569)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.805 57.5007C109.805 86.388 86.3869 109.806 57.4996 109.806V45.5472H108.433C109.33 49.3863 109.805 53.3881 109.805 57.5007Z",
    fill: "url(#paint2_linear_126_569)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5001 115C25.7436 115 -1.38811e-06 89.2564 0 57.5C1.38811e-06 25.7436 25.7437 -1.38812e-06 57.5001 0C89.2565 1.38812e-06 115 25.7436 115 57.5C115 89.2564 89.2565 115 57.5001 115ZM57.5001 5.175C28.6017 5.175 5.175 28.6017 5.175 57.5C5.175 86.3983 28.6017 109.825 57.5001 109.825C86.3984 109.825 109.825 86.3983 109.825 57.5C109.825 28.6017 86.3984 5.175 57.5001 5.175Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.651 45.4883C110.99 45.4883 112.075 46.5736 112.075 47.9124V48.7074C112.075 50.0462 110.99 51.1316 109.651 51.1316L5.34914 51.1316C4.01033 51.1316 2.925 50.0462 2.925 48.7074V47.9124C2.925 46.5736 4.01033 45.4883 5.34914 45.4883L109.651 45.4883Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3217 110.287C60.3217 111.626 59.2364 112.712 57.8976 112.712H57.1026C55.7637 112.712 54.6784 111.626 54.6784 110.287L54.6784 50.7814C54.6784 49.4426 55.7638 48.3573 57.1026 48.3573H57.8976C59.2364 48.3573 60.3217 49.4426 60.3217 50.7814L60.3217 110.287Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_569",
    x1: 84.0632,
    y1: 13.0098,
    x2: 36.8982,
    y2: 104.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_569",
    x1: 26.0842,
    y1: 104.197,
    x2: 65.1077,
    y2: 55.1078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_126_569",
    x1: 60.0859,
    y1: 109.806,
    x2: 99.5137,
    y2: 43.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficientAndHappy);
export default __webpack_public_path__ + "static/media/efficient-and-happy.0fb5f8513bd0f390104afe153277fcb0.svg";
export { ForwardRef as ReactComponent };